import React from 'react';

const DashboardTable = props => {

  const { head, data, filter } = props;

  return (
    <table className="dashboard__table">
      <thead className="dashboard__table__head">
        <tr>
          {/* <th>Maaltijdcomponent</th> */}
          {head.map((title, i) => 
            // <th key={i}>{weekday[title.getDay()]} {title.getDate()}/{title.getMonth()}</th>
            <th key={i}>{title}</th>
          )}
        </tr>
      </thead>
      <tbody className="dashboard__table__body">
        {data.map((row, i) => (
          <tr key={i}>
            {row.map((data, i) => {
              let value = data
              const suffix = "kg";
              const prefix = "€";
              if(parseFloat(data) > 0) {
                value = parseFloat(data).toFixed(2)
                if(filter == 1) value = prefix+value
                else value = value + suffix
              }
              return <td key={i}>{value}</td>
            })}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default DashboardTable;